export const SIDEBAR_ICON_CURRENT = "text-accent-orange";
